import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ClassifiedController::upload
* @see app/Http/Controllers/ClassifiedController.php:886
* @route '/dashboard/classifieds/{classified}/media'
*/
export const upload = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/dashboard/classifieds/{classified}/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::upload
* @see app/Http/Controllers/ClassifiedController.php:886
* @route '/dashboard/classifieds/{classified}/media'
*/
upload.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return upload.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::upload
* @see app/Http/Controllers/ClassifiedController.php:886
* @route '/dashboard/classifieds/{classified}/media'
*/
upload.post = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::upload
* @see app/Http/Controllers/ClassifiedController.php:886
* @route '/dashboard/classifieds/{classified}/media'
*/
const uploadForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::upload
* @see app/Http/Controllers/ClassifiedController.php:886
* @route '/dashboard/classifieds/{classified}/media'
*/
uploadForm.post = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

upload.form = uploadForm

/**
* @see \App\Http\Controllers\ClassifiedController::deleteMethod
* @see app/Http/Controllers/ClassifiedController.php:960
* @route '/dashboard/classifieds/{classified}/media/{mediaId}'
*/
export const deleteMethod = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/dashboard/classifieds/{classified}/media/{mediaId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ClassifiedController::deleteMethod
* @see app/Http/Controllers/ClassifiedController.php:960
* @route '/dashboard/classifieds/{classified}/media/{mediaId}'
*/
deleteMethod.url = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            classified: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
        mediaId: args.mediaId,
    }

    return deleteMethod.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::deleteMethod
* @see app/Http/Controllers/ClassifiedController.php:960
* @route '/dashboard/classifieds/{classified}/media/{mediaId}'
*/
deleteMethod.delete = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ClassifiedController::deleteMethod
* @see app/Http/Controllers/ClassifiedController.php:960
* @route '/dashboard/classifieds/{classified}/media/{mediaId}'
*/
const deleteMethodForm = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::deleteMethod
* @see app/Http/Controllers/ClassifiedController.php:960
* @route '/dashboard/classifieds/{classified}/media/{mediaId}'
*/
deleteMethodForm.delete = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const media = {
    upload: Object.assign(upload, upload),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default media